import React from 'react'
import { useLookupRelationships } from 'src/queries'
import Pagination from './Pagination'

export type RelationshipsModalToggleProps = {
  relationshipModel: string
  optionId: string
} | undefined

export type RelationshipsModalToggle = (newValue?: RelationshipsModalToggleProps) => void

interface BodyProps {
  lookupId: string
  relationshipModel: string
  optionId: string
  toggle: RelationshipsModalToggle
}

const Body: React.FC<BodyProps> = (props) => {
  const { lookupId, relationshipModel, optionId } = props
  const [page, setPage] = React.useState(1)

  const results = useLookupRelationships({
    key: lookupId,
    relationshipModel,
    id: optionId,
    page,
    limit: 15
  })
  const items = results.items
  const pageInfo = results.pageInfo

  if (!Array.isArray(items) || items.length === 0) {
    return (
      <div>No relationships found.</div>
    )
  }

  return (
    <>
      <div className='mb-auto'>
        <ul>
          {items.map((item) => {
            if (typeof item._id !== 'string' || typeof item.title !== 'string') {
              return null
            }
            if (typeof item.link !== 'string') {
              return (
                <li key={item._id}>
                  {item.title}
                </li>
              )
            }
            const baseURL = process.env.REACT_APP_PUBLIC_URL ?? ''
            const itemURL = `${baseURL}${item.link}`
            return (
              <li key={item._id}>
                <a href={itemURL} target='_blank' rel='noopener noreferrer'>
                  {item.title}
                </a>
              </li>
            )
          })}
        </ul>
      </div>
      <div className='w-100 d-flex justify-content-center flex-column align-items-center'>
        <Pagination
          page={pageInfo?.currentPage ?? 1}
          setPage={setPage}
          pageCount={pageInfo?.pageCount ?? 1}
          hasNextPage={pageInfo?.hasNextPage ?? false}
          hasPreviousPage={pageInfo?.hasPreviousPage ?? false}
        />
      </div>
    </>
  )
}

export default Body
